import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import styled from 'styled-components';

import Login from './components/Account/Login';
import PatientLogin from './components/Patient/Login';
import MultiFactorAuthentication from './components/Account/MultiFactorAuth';
import VerificationForDevice from './components/Account/VerificationForDevice'
import ResetPassword from './components/Account/ResetPassword';
import AuthenticateUser from './components/auth/Authentication';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import Dashboard from './components/Dashboard/Dashboard';
import ForgotPassword from './components/Account/ForgotPassword';
import AlertNotifier from './components/AlertNotifier/AlertNotifier';
import MultiFactorVerification from './components/Account/MultiFactorVerification';

const MainWrapper = styled.div`
  height: inherit;
`;

const AuthenticatedDashboard = AuthenticateUser(Dashboard);

const PublicRoutes = () => {

  return (
    <MainWrapper className='main-wrapper'>
      <ErrorBoundary>
        <AlertNotifier />
        <Switch>
          <Redirect exact from='/' to='/login' />      
          <Route exact path='/patient/login' component={PatientLogin} />
          <Route exact path='/login' component={Login} />
          <Route exact path='/multi-factor-authentication' component={MultiFactorAuthentication} />
          <Route path="/multi-factor-verification" component={MultiFactorVerification} />
          <Route exact path='/verification-for-device' component={VerificationForDevice} />
          <Route exact path='/forgot-password' component={ForgotPassword} />
          <Route exact path='/password/reset/confirm/:uid/:token' component={ResetPassword} />
          <Route path='/auth' component={AuthenticatedDashboard} />
          <Redirect to='/login' />
        </Switch>
      </ErrorBoundary>
    </MainWrapper>
  );
};

export default PublicRoutes;
